export const ANIMATE_LIVE_TICKER = true;
export const ENABLE_FETCH_ALL_IG_POSTS = false; // Fetch paginated posts from IG when enabled.
export const ENABLE_IG_POSTS_CAROUSEL = false; // Show carousel for posts with more than one pictures
export const HIDE_DUMMY_ITEMS =
  process.env.GATSBY_AFEX_NODE_ENV === 'production';
